import { Controller } from "@hotwired/stimulus"
import {
  createHereMap,
  disposeHereMap,
  circleIcon,
  singleBubble,
} from "../helpers/here_map_helpers"

const DEFAULT_COLOR = "#149d71"

// Group dashboard site map: like dashboard_sites_map_controller, but each marker
// carries its own tenant colour (marker.color) instead of a severity lookup, so a
// group owner can tell each company's sites apart on one map.
export default class extends Controller {
  static targets = ["map"]
  static values = { markers: Array }

  connect() {
    createHereMap(this.mapTarget, { center: this.computeCenter(), zoom: 6 })
      .then((ctx) => this.addMarkers(ctx))
      .catch((error) => console.error("HERE map failed to load", error))
  }

  disconnect() {
    disposeHereMap(this.map)
    this.map = null
  }

  addMarkers({ H, map, ui }) {
    this.map = map
    const showBubble = singleBubble(H, ui)

    this.markersValue.forEach((marker) => {
      const position = { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }
      const object = new H.map.Marker(position, {
        icon: circleIcon(marker.color || DEFAULT_COLOR),
      })
      object.addEventListener("tap", () => showBubble(position, this.label(marker)))
      map.addObject(object)
    })
  }

  // A DOM node rather than an HTML string: site and tenant names are user input.
  label(marker) {
    const node = document.createElement("div")
    node.className = "whitespace-nowrap text-sm font-medium"
    node.textContent = marker.tenant ? `${marker.name} — ${marker.tenant}` : marker.name
    return node
  }

  computeCenter() {
    if (!this.markersValue.length) return { lat: 51.1657, lng: 10.4515 }

    const lats = this.markersValue.map((m) => parseFloat(m.lat))
    const lngs = this.markersValue.map((m) => parseFloat(m.lng))
    return {
      lat: (Math.min(...lats) + Math.max(...lats)) / 2,
      lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
    }
  }
}
